module.exports = __webpack_public_path__ + "static/media/icon-cuisine.bd33fe69.png";